module.exports = __webpack_public_path__ + "img/map-active.543540b5.svg";